export const useZObjectWidth = ({zobject, text}) => {
    let width = 0;
    
    if (text.length > 0) {
        let _width = text.length+6;
        width = (text.length + 6) + "ch";
        
        let numInlets = zobject.numInlets;
        if (zobject.effect && zobject.effect.numInlets) {
            numInlets += zobject.effect.numInlets;
        }

        if (numInlets*4 > _width) {
            _width = numInlets*4;
            width = numInlets*4 + "ch";
        }

        let numOutlets = zobject.numOutlets;
        if (zobject.effect && zobject.effect.numOutlets) {
            numOutlets += zobject.effect.numOutlets;
        }


        if (numOutlets * 4 > _width) {
            width = numOutlets*4 + "ch";
        }
    }
    return width;
};
